import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { AccessControlService } from './access-control/services/access-control.service';

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(
        private router: Router,
        private keycloakService: KeycloakService,
        private accessControlService: AccessControlService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const expectedRoles: string[] = next.data['expectedRoles'] ?? [];
        const expectedPermissions: string[] =
            next.data['expectedPermissions'] ?? [];

        const roles = this.keycloakService.getUserRoles();
        const tieneRol = expectedRoles.some((role) => roles.includes(role));
        const tienePermiso =
            this.accessControlService.tieneAlgunoDeLosPermisos(
                expectedPermissions
            );

            console.log('[RoleGuard] tieneRol:', tieneRol, 'tienePermiso:', tienePermiso);
        if (tieneRol || tienePermiso) {
            return true;
        }

        this.router.navigate(['/inicio']);
        return false;
    }
}
